// import React from 'react';
import withRollingText from './rolling-text-hoc';
import { Heading } from 'src/components/common/typography';

export default withRollingText(Heading);